import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Role } from '../enums/role';

export class MenuItem {
  label: string;
  icon?: string;
  route: string;
  id: number;
  children?: {
    id: number;
    label: string;
    route: string;
  }[];
}

@Injectable({ providedIn: 'root' })
export class MenuService {
  private authService = inject(AuthService);
  getMenuItems(): MenuItem[] {
    const currentUser = this.authService.currentUser$();
    const menu: MenuItem[] = [
      { id: 1, label: 'Dashboard', icon: 'mat_solid:assessment', route: '/apps/dashboard' },
      {
        id: 2,
        label: 'Historique des évaluations',
        icon: 'mat_solid:article',
        route: '/apps/history',
      },
      { id: 3, label: 'Compte', icon: 'mat_solid:settings', route: '/apps/setting' },
    ];
    if (currentUser && currentUser.role === Role.manager) {
      menu.push({
        id: 4,
        label: 'Utilisateurs',
        icon: 'heroicons_solid:user',
        route: '/apps/users',
        children: [
          { id: 41, label: 'Ajout Utilisateur', route: '/apps/users/invite' },
          { id: 42, label: 'Modifier Utilisateur', route: '/apps/users/:id' },
        ],
      });
    }
    return menu;
  }
}
